import { EventBus } from 'utils/event-bus';
import { handleUploadImageFile } from './UploadImageFile';

const toast_size = { type: 'Error', message: 'Sorry! Invalid file size. (Max. 5MB)', time: 5000 };
const toast_invalid = { type: 'Error', message: 'Sorry! Invalid file. (Only images accepted)', time: 5000 };

export const handleValidateImageUpload = (files, tinyMCE, imageUploader) => {
  if (files[0].size > 5000000) {
    EventBus.$emit('createToast', toast_size);
    return;
  }
  if (!files[0].type.includes('image/')) {
    EventBus.$emit('createToast', toast_invalid);
    return;
  }
  handleUploadImageFile(files, tinyMCE, imageUploader);
};


// WEBPACK FOOTER //
// ./src/app/components/modals/New_RoundTable/EditorMCE/Utils/ValidateImageUpload.js